import script from "./pc-module-disease-coverage-1.vue?vue&type=script&lang=ts&setup=true"
export * from "./pc-module-disease-coverage-1.vue?vue&type=script&lang=ts&setup=true"

import "./pc-module-disease-coverage-1.vue?vue&type=style&index=0&id=3b466458&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b466458"]])

export default __exports__